module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_nyeregteto_szurke.a216cf9c.png";